import axios from "axios";

export const setupAxiosInterceptors = (keycloak) => {
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // If error is 401 Unauthorized or 403 Forbidden and not already retrying
      if (
        (error.response?.status === 401 || error.response?.status === 403) &&
        !originalRequest._retry &&
        keycloak &&
        keycloak.token
      ) {
        originalRequest._retry = true;

        try {
          // Try to update the token
          const refreshed = await keycloak.updateToken(30);

          if (refreshed) {
            // Update the authorization header with the new token
            originalRequest.headers[
              "Authorization"
            ] = `Bearer ${keycloak.token}`;
            return axios(originalRequest);
          }
        } catch (refreshError) {
          console.error("Token refresh failed during API call:", refreshError);
          // Optional: Redirect to login if refresh fails
          // keycloak.login();
        }
      }

      return Promise.reject(error);
    }
  );
};
